/* Sector landing pages (sections/bd-sector-landing.liquid).
   1. Help me choose: recommends one existing range from the material rules
      (dry: MFC, damp: moisture-resistant MFC, wet: compact grade laminate),
      never from price, and links to its configurator or to the Washroom
      Builder with the same answers (?sector= ?wet= ?look= ?range=).
   2. Quote dialog: Shopify contact form with the sector as hidden fields.
   3. GA4 events through the Google channel's gtag (consent mode is applied
      there), like bd-cubicles-collection.js. No personal data in events.
   The sector page is remembered for the session (bd_sector_entry) so the
   Washroom Builder can name it on its own quote requests and events. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sx]');
  if (!root) return;

  var SECTOR = root.getAttribute('data-sector') || '';
  var ENTRY = root.getAttribute('data-entry') || '';
  var BUILDER = root.getAttribute('data-builder') || '/pages/washroom-builder';
  var RANGES = {};
  try { RANGES = JSON.parse((root.querySelector('[data-sx-ranges]') || {}).textContent || '{}'); } catch (e) {}

  function track(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      params = params || {};
      params.page_type = 'sector_page';
      params.sector = SECTOR;
      params.entry_page = ENTRY;
      params.transport_type = 'beacon';
      window.gtag('event', name, params);
    } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  try { sessionStorage.setItem('bd_sector_entry', JSON.stringify({ sector: SECTOR, page: ENTRY, t: Date.now() })); } catch (e) {}
  track('sector_page_view');

  /* ---------- Click tracking ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a, button');
    if (!a || !root.contains(a)) return;
    if (a.hasAttribute('data-sx-range')) {
      track('sector_range_click', {
        range: a.getAttribute('data-sx-range'),
        link_type: a.getAttribute('data-sx-link') || 'link',
        position: Number(a.getAttribute('data-sx-pos')) || 0
      });
    } else if (a.hasAttribute('data-sx-builder')) {
      track('washroom_builder_click', { placement: a.getAttribute('data-sx-builder'), builder_sector: a.getAttribute('data-sx-bsector') || '' });
    } else if (a.hasAttribute('data-sx-xs')) {
      track('cross_sell_click', { category: a.getAttribute('data-sx-xs'), material: a.getAttribute('data-sx-material') || '' });
    } else if (a.hasAttribute('data-sx-call')) {
      track('quote_request_click', { method: 'phone' });
    } else if (a.hasAttribute('data-sx-track')) {
      track('sector_cta_click', { cta: a.getAttribute('data-sx-track') });
    }
  });

  /* ---------- Help me choose ---------- */
  var toggle = root.querySelector('[data-sx-help-toggle]');
  var tool = root.querySelector('[data-sx-tool]');
  var form = root.querySelector('[data-sx-form]');
  var out = root.querySelector('[data-sx-result]');
  var resetBtn = root.querySelector('[data-sx-reset]');
  var lastRec = null;

  var LABELS = {
    age: { under5: 'Under-fives', shared: 'Shared with reception or KS1', primary: 'Primary', secondary: 'Secondary or staff' },
    wet: { dry: 'Dry', damp: 'Damp', wet: 'Wet' },
    look: { standard: 'Standard height', full: 'Floor to ceiling', any: 'Height not decided' },
    use: { normal: 'Steady public use', heavy: 'Very high footfall or misuse' }
  };
  // The floor-to-ceiling version of a standard-height pick, and back.
  var TALL = { smart: 'ridge', ascent: 'ridge', alpine: 'summit' };

  function answers() {
    var a = {};
    if (!form) return a;
    Array.prototype.forEach.call(form.querySelectorAll('input[type=radio]:checked'), function (i) {
      var fs = i.closest('[data-q]');
      if (fs && !fs.hidden) a[i.name] = i.value;
    });
    return a;
  }
  function syncConditional(a) {
    Array.prototype.forEach.call(form.querySelectorAll('[data-when]'), function (fs) {
      var cond = fs.getAttribute('data-when').split('=');
      fs.hidden = a[cond[0]] !== cond[1];
    });
  }
  function required() {
    return Array.prototype.filter.call(form.querySelectorAll('[data-q]'), function (fs) {
      return !fs.hidden && fs.getAttribute('data-q') !== 'look';
    }).map(function (fs) { return fs.getAttribute('data-q'); });
  }
  function builderSector(a) {
    if (SECTOR === 'education') return a.age === 'under5' ? 'nursery' : (a.age === 'primary' ? 'primary' : 'secondary');
    if (SECTOR === 'nursery') return 'nursery';
    return SECTOR;
  }

  // Material rules only: wetness picks the board, the height picks the format.
  function decide(a) {
    var look = a.look || 'any';
    var r = { key: '', why: '', alt: '', caution: '' };
    if (a.age === 'under5' || a.age === 'shared' || a.age === 'primary') {
      r.key = a.age === 'under5' ? 'tippy' : 'blossom';
      r.why = r.key === 'tippy'
        ? 'For under-fives: Tippy Toes is low level throughout (1150mm overall), with shaped pilasters and doors and anti-finger-trap detailing, so staff can see across the run.'
        : 'Blossom pairs 1200mm doors with 1950mm full-height partitions: staff keep a sightline over the doors and each child has a solid divide from the next cubicle.';
      r.alt = r.key === 'tippy' ? 'blossom' : 'tippy';
      if (a.wet === 'wet') {
        r.caution = 'Tippy Toes and Blossom are 18mm moisture-resistant MFC, for washrooms wiped clean or mopped daily. If this room sits next to showers or gets wet, send us the layout before you order and we\'ll confirm the right board.';
      }
      return r;
    }
    var wet = a.wet || 'dry';
    if (SECTOR === 'public' && a.use === 'heavy' && wet !== 'wet') {
      r.key = look === 'full' ? 'summit' : 'alpine';
      r.why = 'For very high footfall or misuse, compact grade laminate is solid all the way through, so there is no chipboard core to expose or swell if a panel is damaged.';
    } else if (wet === 'wet') {
      r.key = look === 'full' ? 'summit' : 'alpine';
      r.why = 'Wet areas need compact grade laminate: 13mm solid board with no chipboard core to swell at a cut edge.';
      r.caution = 'If the cubicles will stand inside a shower area, send us the layout and we\'ll check the details with you before you order.';
    } else if (wet === 'damp') {
      r.key = look === 'full' ? 'ridge' : 'ascent';
      r.why = look === 'full'
        ? 'Ridge runs floor to ceiling with an overhead panel above every door, in 18mm moisture-resistant MFC for washrooms cleaned wet every day.'
        : 'For washrooms cleaned wet every day, 18mm moisture-resistant MFC holds up where standard MFC can swell at a cut edge.';
    } else {
      r.key = look === 'full' ? 'ridge' : 'smart';
      r.why = look === 'full'
        ? 'Ridge runs floor to ceiling with an overhead panel above every door, for a fully enclosed washroom.'
        : 'For a dry washroom that is wiped clean, Smart\'s 18mm MFC is the economical full-height choice.';
    }
    if (look === 'any' && TALL[r.key]) r.alt = TALL[r.key];
    return r;
  }

  function builderUrl(a, key) {
    var q = new URLSearchParams();
    var bs = builderSector(a);
    if (bs) q.set('sector', bs);
    if (a.wet) q.set('wet', a.wet);
    if (a.look && a.look !== 'any') q.set('look', a.look);
    if (key) q.set('range', key);
    q.set('pkg', 'all');
    q.set('step', '0');
    return BUILDER + '?' + q.toString();
  }
  function summary(a, key) {
    var parts = [];
    ['age', 'wet', 'use', 'look'].forEach(function (k) { if (a[k] && LABELS[k][a[k]]) parts.push(LABELS[k][a[k]]); });
    return parts.join(', ') + (key && RANGES[key] ? ' → ' + RANGES[key].name : '');
  }

  function render(fromUser) {
    if (!form || !out) return;
    var a = answers();
    syncConditional(a);
    a = answers();
    var missing = required().filter(function (k) { return !a[k]; });
    if (resetBtn) resetBtn.hidden = !Object.keys(a).length;
    try { history.replaceState(Object.assign({}, history.state || {}, { sx: a, sxOpen: true }), ''); } catch (e) {}
    if (missing.length) { out.innerHTML = ''; lastRec = null; return; }
    var r = decide(a);
    var R = RANGES[r.key];
    if (!R || !R.url) { out.innerHTML = ''; return; }
    lastRec = { key: r.key, answers: a };
    var alt = r.alt && RANGES[r.alt] ? RANGES[r.alt] : null;
    var altText = '';
    if (alt) {
      altText = (r.key === 'tippy') ? 'Shared with reception or Key Stage 1? '
        : (r.key === 'blossom') ? 'Under-fives only? '
        : 'Want them fully enclosed? ';
      altText += '<a href="' + esc(alt.url) + '" data-sx-range="' + esc(r.alt) + '" data-sx-link="chooser_alt">' + esc(alt.name) + '</a>' + (alt.from ? ', from ' + esc(alt.from) + ' + VAT.' : '.');
    }
    out.innerHTML =
      '<div class="sx-rec">' +
        '<p class="sx-rec__k">Our recommendation</p>' +
        '<p class="sx-rec__name">' + esc(R.name) + '</p>' +
        '<p class="sx-rec__why">' + esc(r.why) + '</p>' +
        '<p class="sx-rec__mat">' + esc(R.material) + ' · ' + esc(R.privacy) + '</p>' +
        (R.from ? '<p class="sx-rec__price"><span class="sx-card__from">From</span> <strong>' + esc(R.from) + '</strong> <span class="sx-card__vat">+ VAT</span></p>' : '') +
        (r.caution ? '<p class="sx-rec__caution">' + esc(r.caution) + ' <button type="button" class="sx-link" data-sx-quote-open="chooser">Ask us</button></p>' : '') +
        '<div class="sx-rec__actions">' +
          '<a class="sx-btn sx-btn--primary" href="' + esc(R.url) + '" data-sx-range="' + esc(r.key) + '" data-sx-link="chooser">Configure ' + esc(R.name.replace(/ Range$/, '')) + ' &amp; price <span aria-hidden="true">→</span></a>' +
          '<a class="sx-btn sx-btn--secondary" href="' + esc(builderUrl(a, r.key)) + '" data-sx-builder="chooser" data-sx-bsector="' + esc(builderSector(a)) + '">Plan the whole washroom</a>' +
        '</div>' +
        (altText ? '<p class="sx-rec__alt">' + altText + '</p>' : '') +
      '</div>';
    if (fromUser) track('sector_recommend', { range: r.key, moisture: a.wet || '', look: a.look || '', age: a.age || '', use: a.use || '' });
  }

  function openTool(source) {
    if (!tool || !toggle) return;
    tool.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    if (source) track('sector_help_open', { source: source });
  }
  if (toggle && tool) {
    toggle.addEventListener('click', function () {
      var open = tool.hidden;
      tool.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        track('sector_help_open', { source: 'button' });
        var first = form && form.querySelector('input');
        if (first) first.focus();
      }
      try { history.replaceState(Object.assign({}, history.state || {}, { sxOpen: open }), ''); } catch (e) {}
    });
  }
  if (form) {
    form.addEventListener('change', function () { render(true); });
    form.addEventListener('submit', function (e) { e.preventDefault(); });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      form.reset();
      render(false);
      var first = form.querySelector('input');
      if (first) first.focus();
    });
  }
  // Back from a configurator: restore the answers and the recommendation.
  (function restore() {
    var st = history.state || {};
    if (st.sx && form) {
      Object.keys(st.sx).forEach(function (k) {
        var i = form.querySelector('input[name="' + k + '"][value="' + st.sx[k] + '"]');
        if (i) i.checked = true;
      });
    }
    if (st.sxOpen || location.hash === '#help') { openTool(); render(false); }
  })();

  /* ---------- Quote dialog ---------- */
  var dlg = root.querySelector('[data-sx-quote]');
  function fillQuote() {
    if (!dlg || !lastRec) return;
    var sel = dlg.querySelector('[data-sx-quote-range]');
    if (sel) {
      var opt = sel.querySelector('option[data-range="' + lastRec.key + '"]');
      if (opt) sel.value = opt.value;
    }
    var hid = dlg.querySelector('[data-sx-quote-answers]');
    if (hid) hid.value = summary(lastRec.answers, lastRec.key);
  }
  function openQuote(placement) {
    fillQuote();
    dlg.showModal();
    var first = dlg.querySelector('input:not([type=hidden])') || dlg.querySelector('button');
    if (first) first.focus();
    track('quote_request_click', { method: 'form', placement: placement || '' });
  }
  if (dlg && typeof dlg.showModal === 'function') {
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sx-quote-open]');
      if (o) { e.preventDefault(); openQuote(o.getAttribute('data-sx-quote-open')); return; }
      if (e.target.closest('[data-sx-quote-close]')) dlg.close();
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    // After Shopify posts the form back, show the outcome in the dialog.
    var state = dlg.querySelector('[data-sx-quote-state]');
    if (state) {
      dlg.showModal();
      if (state.getAttribute('data-sx-quote-state') === 'sent') {
        var key = 'sx_lead_' + location.pathname;
        var done = false;
        try { done = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (e) {}
        if (!done) track('generate_lead', { lead_source: 'sector_page_quote' });
        try { var u = new URL(location.href); u.searchParams.delete('contact_posted'); history.replaceState(history.state, '', u.pathname + u.search); } catch (e) {}
      }
    }
  }
})();
